var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { Events } from '../utils/events';
import { API } from './api';
import { BrainVersionType } from '../providers/brain';
import * as MathUtils from '../utils/math';
var AnomalySliderProvider = /** @class */ (function () {
    function AnomalySliderProvider(api, events) {
        this.api = api;
        this.events = events;
    }
    AnomalySliderProvider.prototype.kickoffSaveNormalThresholdJob = function (datasetIdentifier, brainVersionType, normalThreshold) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/normal-threshold", {
                            normalThreshold: normalThreshold,
                            brainVersionType: brainVersionType,
                            runAsJob: true
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.jobIdentifier];
                }
            });
        });
    };
    AnomalySliderProvider.prototype.kickoffUpdateAdherenceToNormalJob = function (datasetIdentifier, adherenceToNormal, brainVersionType) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/adherence-to-normal?runAsJob=1", {
                            adherenceToNormal: adherenceToNormal,
                            createNewBrainVersion: true,
                            brainVersionType: brainVersionType
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.jobIdentifier];
                }
            });
        });
    };
    /**
     * Generate a simple set of slider bounds that encompasses all frames
     */
    AnomalySliderProvider.prototype.generateSimpleSliderBounds = function (brainVersionType, frameGTScores, paddingPercentage) {
        if (paddingPercentage === void 0) { paddingPercentage = 0; }
        if (!frameGTScores || frameGTScores.length == 0) {
            return null;
        }
        var classBoundsMap = this.generateClassBoundsMap(frameGTScores);
        return this.generateSimpleSliderBoundsFromClassBoundsMap(brainVersionType, classBoundsMap, paddingPercentage);
    };
    AnomalySliderProvider.prototype.generateSimpleSliderBoundsFromClassBoundsMap = function (brainVersionType, classBoundsMap, paddingPercentage) {
        if (paddingPercentage === void 0) { paddingPercentage = 0; }
        if (classBoundsMap.All.min === null || classBoundsMap.All.max === null) {
            return null;
        }
        var bounds = this.getBrainVersionTypeBounds(brainVersionType);
        var min = MathUtils.clamp(classBoundsMap.All.min * (1 - paddingPercentage), bounds.min, bounds.max);
        var max = MathUtils.clamp(classBoundsMap.All.max * (1 + paddingPercentage), bounds.min, bounds.max);
        return {
            min: Math.round(min * 1000) / 1000,
            max: Math.round(max * 1000) / 1000
        };
    };
    AnomalySliderProvider.prototype.generateClassBoundsMap = function (frameGTScores) {
        var classBoundsMap = {
            Normal: {
                min: null,
                max: null
            },
            Anomaly: {
                min: null,
                max: null
            },
            All: {
                min: null,
                max: null
            }
        };
        for (var _i = 0, frameGTScores_1 = frameGTScores; _i < frameGTScores_1.length; _i++) {
            var frameGTScore = frameGTScores_1[_i];
            var gt = frameGTScore.actualClass;
            var normalScore = frameGTScore.normalScore;
            if (classBoundsMap[gt] == undefined) {
                continue;
            }
            if (classBoundsMap[gt].min === null || normalScore < classBoundsMap[gt].min) {
                classBoundsMap[gt].min = normalScore;
            }
            if (classBoundsMap[gt].max === null || normalScore > classBoundsMap[gt].max) {
                classBoundsMap[gt].max = normalScore;
            }
            if (classBoundsMap.All.min === null || normalScore < classBoundsMap.All.min) {
                classBoundsMap.All.min = normalScore;
            }
            if (classBoundsMap.All.max === null || normalScore > classBoundsMap.All.max) {
                classBoundsMap.All.max = normalScore;
            }
        }
        return classBoundsMap;
    };
    AnomalySliderProvider.prototype.toSliderValue = function (realValue) {
        return Math.round(realValue * 1000);
    };
    // NOTE: The bounds passed in should be rounded using toSliderValue().
    AnomalySliderProvider.prototype.hasEnoughData = function (bounds) {
        return bounds && bounds.min !== null && bounds.max !== null && bounds.min != bounds.max;
    };
    AnomalySliderProvider.prototype.getLearningBounds = function () {
        return {
            min: 1,
            max: null
        };
    };
    AnomalySliderProvider.prototype.getAnomalyHiFiBounds = function () {
        return {
            min: 0,
            max: 1
        };
    };
    AnomalySliderProvider.prototype.getBrainVersionTypeBounds = function (brainVersionType) {
        if (brainVersionType == BrainVersionType.AnomalyHiFi) {
            return this.getAnomalyHiFiBounds();
        }
        else {
            return this.getLearningBounds();
        }
    };
    AnomalySliderProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [API, Events])
    ], AnomalySliderProvider);
    return AnomalySliderProvider;
}());
export { AnomalySliderProvider };
//# sourceMappingURL=anomaly_slider.js.map


// WEBPACK FOOTER //
// ./src/providers/anomaly_slider.ts.pre-build-optimizer.js